import { FormData } from "../../types";

export const FORM_DATA: FormData = {
  entities: {
    pages: {
      byId: {},
      allIds: [],
    },
    sections: {
      byId: {},
      allIds: [],
    },
    parts: {
      byId: {},
      allIds: [],
    },
    conditions: {
      byId: {},
      allIds: [],
    },
  },
  post: {},
  image: "",
  app_version: "",
};
